import { render } from "./CommonSignaturePad.vue?vue&type=template&id=68704fd0"
import script from "./CommonSignaturePad.vue?vue&type=script&lang=js"
export * from "./CommonSignaturePad.vue?vue&type=script&lang=js"

import "./CommonSignaturePad.vue?vue&type=style&index=0&id=68704fd0&lang=scss"

import exportComponent from "C:\\geneuin\\developer\\hwian\\hwian-install-mobile-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__